import { render } from "./ProfilePopoverOptions.vue?vue&type=template&id=2e990567"
import script from "./ProfilePopoverOptions.vue?vue&type=script&lang=js"
export * from "./ProfilePopoverOptions.vue?vue&type=script&lang=js"
script.render = render

export default script